module.exports = __webpack_public_path__ + "static/media/video_wine.504c6b8f.svg";